import { authRoles } from './auth/authRoles'

export const navigations = [
    // {
    //     name: 'Dashboard',
    //     path: '/dashboard',
    //     icon: 'dashboard',
    //     auth: authRoles.dashboard
    // },

    // {
    //     name: 'Aptitute Test',
    //     icon: 'table_view',
    //     auth: authRoles.aptituteTest,
    //     children: [
    //         {
    //             name: 'All',
    //             path: '/aptitutetest/all',
    //             iconText: 'T1',
    //             auth: authRoles.aptituteTestView,
    //         },
    //         {
    //             name: 'Create',
    //             path: '/aptitutetest/create',
    //             iconText: 'T2',
    //             auth: authRoles.aptituteTestCreate,
    //         },
    //         {
    //             name: 'New Test Paper',
    //             path: '/data-table/expandable-mui-table',
    //             iconText: 'T2',
    //             auth: authRoles.TestPaperCreate,
    //         },
    //         {
    //             name: 'All Appications',
    //             path: '/data-table/expandable-mui-table',
    //             iconText: 'T2',
    //             auth: authRoles.appicationView,
    //         },
    //     ],
    // },
    {
        name: 'Dashboard',
        path: '/Dashboard',
        icon: 'person',
        auth: authRoles.aptituteTestCreate,
    },
    {
        name: 'User Management',
        path: '/users',
        icon: 'person',
        auth: authRoles.userManagement,
    },
    {
        name: 'User Management',
        path: '/orgadmin/users',
        icon: 'person',
        auth: authRoles.orgAdminUserManagement,
    },
    // {
    //     name: 'User',
    //     path: '/user/add',
    //     icon: 'person',
    //     auth: authRoles.registerUserOrgContributor,
        
    // },
    
    {
        name: 'Add New Organization',
        path: '/Organization/newOrg',
        icon: 'corporate_fare',
        auth: authRoles.addNewOrganization,
    },
    {
        name: 'Organization Management',
        path: '/Organization/OrgManagement',
        icon: 'corporate_fare',
        auth: authRoles.orgManagement,
    },
    {
        name: 'Portal',
        path: '/Portals/viewerportal',
        icon: 'table_view',
        auth: authRoles.viewerPortal,
    },
    {
        name: 'Portal',
        path: '/Portals/organization_admin_portal',
        icon: 'table_view',
        auth: authRoles.orgAdminPortal,
    },
    {
        name: 'Portal',
        path: '/Portals/organization_contributor_portal',
        icon: 'table_view',
        auth: authRoles.orgContributorPortal,
    },
    {
        name: 'Portal',
        path: '/contributor/portal',
        icon: 'table_view',
        auth: authRoles.individualContributorPortal,
    },
    {
        name: 'Portal',
        path: '/admin/portal',
        icon: 'table_view',
        auth: authRoles.AdminPortal,
    },
    // {
    //     name: 'My Profile',
    //     path: '/user/myprofile',
    //     icon: 'person',
    //     auth: authRoles.myProfile,
    // },
    {
        name: 'Configurations',
        icon: 'settings',
        auth: authRoles.configurations,
        children: [
            // {
            //     name: 'SDG Configurations',
            //     path: '/configurations/sdg',
            //     iconText: '',
            //     auth:authRoles.aptituteTestCreate
            // },
            {
                name: 'Target Configurations',
                path: '/configurations/target',
                iconText: '',
                auth:authRoles.targetConfiguration
            },
            {
                name: 'Organization Configurations',
                path: '/configurations/org_config',
                iconText: '',
                auth:authRoles.orgConfiguration
            },
            {
                name: 'Expense Configurations',
                path: '/configurations/expense_config',
                iconText: '',
                auth:authRoles.expenseConfiguration
            }
        ]
    },
    // {
    //     name: 'Expense Dashboards',
    //     icon: 'money',
    //     auth: authRoles.expenseDashboards,
    //     children: [
    {
        name: 'Add Expense',
        path: '/expense/addexpense',
        icon: 'money',
        auth: authRoles.AddExpense,
    },
    {
        name: 'Expense Dashboard',
        path: '/viewer/expensedashboard',
        icon: 'money',
        auth: authRoles.viewerExpenseDashboard,
    },
    {
        name: 'Expense Dashboard',
        path: '/contributor/expensedashboard',
        icon: 'money',
        auth: authRoles.individualContributorExpenseDashboard,
    },
    {
        name: 'Expense Dashboard',
        path: '/orgcontributor/expensedashboard',
        icon: 'money',
        auth: authRoles.orgContributorExpenseDashboard,
    },
    {
        name: 'Expense Dashboard',
        path: '/orgadmin/expensedashboard',
        icon: 'money',
        auth: authRoles.orgAdminExpenseDashboard,
    },
    {
        name: 'Expense Dashboard',
        path: '/admin/expensedashboard',
        icon: 'money',
        auth: authRoles.AdminExpenseDashboard,
    },
    //     ],
    // }, 

]

